export const GRADE_COLORS: Record<number, string> = {
  1: "#16a34a",
  2: "#84cc16",
  3: "#f59e0b",
  4: "#f97316",
  5: "#dc2626",
  6: "#991b1b",
};

export function getGradeColor(grade: number | null | undefined): string {
  return grade != null && GRADE_COLORS[grade] ? GRADE_COLORS[grade] : "#6b7280";
}
